module.exports = __webpack_public_path__ + "static/media/profile.cc6e06d2.png";